import { ICellRendererParams } from '@ag-grid-community/core';
import { Component } from '@angular/core';
import { Logger } from '@utils/logger';

const logger = Logger.getLogger('NavCellRendererComponent');

@Component({
  selector: 'ft-nav-cell-renderer',
  templateUrl: './nav-cell-renderer.component.html',
  styleUrls: ['./nav-cell-renderer.component.scss'],
})
export class NavCellRendererComponent {
  data: any;
  suppressNavChange: boolean;

  agInit(params: ICellRendererParams) {
    this.data = params.data;
    this.suppressNavChange = params.colDef.cellRendererParams.suppressNavChange;
  }
}
